import type { MouseEventHandler } from 'react';
import { sendGoogleAnalyticsEvents } from '@elfsight/lib-google-analytics';
import { usePopup } from '../../popup';
import { useSocialFeedSettings } from '../../utils';
import { usePost } from '../Post';

export function usePostAction(): MouseEventHandler<HTMLElement> | undefined {
  const {
    id,
    index,
    source: { url: sourceUrl = '' }
  } = usePost();
  const {
    editMode,
    postAction,
    openLinksNewTab,
    googleAnalytics = [],
    widgetId = ''
  } = useSocialFeedSettings();
  const { open } = usePopup();

  if (postAction === 'popup') {
    return (e) => {
      let isLinkClick = false;

      if (e.target instanceof HTMLElement) {
        isLinkClick = !!e.target.closest('a');
      }

      if (isLinkClick) {
        return;
      }

      sendGoogleAnalyticsEvents({
        eventType: 'postPopupOpened',
        googleAnalyticsEvents: googleAnalytics,
        editMode,
        valueMapping: {
          widgetId,
          postId: id,
          postUrl: sourceUrl
        }
      });

      open(index);
    };
  }

  if (postAction === 'follow' && sourceUrl) {
    return () => {
      sendGoogleAnalyticsEvents({
        eventType: 'socialPlatformOpened',
        googleAnalyticsEvents: googleAnalytics,
        editMode,
        valueMapping: {
          widgetId,
          postId: id,
          postUrl: sourceUrl,
          entryPoint: 'post'
        }
      });

      window.open(sourceUrl, openLinksNewTab || editMode ? '_blank' : '_top');
    };
  }

  return;
}
